<script>
export default {
  props: ["title", "projects", "closedDateText", "expanded", "hideDateColumn"],
  data() {
    return {
      open: this.expanded,
    };
  },
  computed: {
    sortedProjects: function () {
      let { projects } = JSON.parse(this.projects);
      const projectsSortedByDate = projects.sort((a, b) => {
        let dateA = new Date(a.date);
        let dateB = new Date(b.date);
        return dateB - dateA;
      });
      return projectsSortedByDate;
    },
  },
  methods: {
    openBody() {
      this.open = !this.open;
    },
  },
};
</script>

<template>
  <div class="fpblock-container container" @click="openBody">
    <div class="row fpblock-header-clickable">
      <div class="col-md-10 offset-md-1 col-lg-9 offset-lg-2">
        <div class="fpblock-header">
          <h3 v-if="title" class="heading-level-3">
            {{ title }}
          </h3>
          <button class="fpblock-header__button">
            <span class="material-icons">
              <template v-if="open">keyboard_arrow_up</template>
              <template v-else>keyboard_arrow_down</template>
            </span>
          </button>
        </div>
      </div>
    </div>
    <div class="fpblock-body row" v-if="open" @click.stop>
      <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <ul class="list-unstyled" v-if="projects">
          <li v-if="!this.hideDateColumn" class="fpblock-li-header">
            <span>{{ closedDateText }}</span>
          </li>
          <li v-for="(project, index) in sortedProjects" :key="index">
            <div class="fpblock-key">
              <a :title="project.key" :href="project.url">
                {{ project.key }}
              </a>
            </div>
            <div v-if="!this.hideDateColumn" class="fpblock-date">
              <span>{{ project.date }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
